/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceSupplierDto } from '../../models/device-supplier-dto';

export interface GetDeviceSuppliers$Params {
}

export function getDeviceSuppliers(http: HttpClient, rootUrl: string, params?: GetDeviceSuppliers$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceSupplierDto>> {
  const rb = new RequestBuilder(rootUrl, getDeviceSuppliers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceSupplierDto>;
    })
  );
}

getDeviceSuppliers.PATH = '/api/nms/suppliers';
